export default __webpack_public_path__ + "static/media/reports_dashboard.d4841565.svg";